// src\utils\isTokenValid.js

import { jwtDecode } from "jwt-decode";                             

export const isTokenValid = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
    return decoded.exp > currentTime; // Token is valid if `exp` is in the future
  } catch (error) {
    console.error("Invalid token:", error);
    return false;
  }
};